import type { SolanaConverterArgs } from '../type'

interface InstructionPatternOptions {
  pattern: {
    programId: string
    instructionType?: string
    accounts?: Record<string, number>
  }
}

export function matchInstructionPattern(
  args: SolanaConverterArgs,
  options: InstructionPatternOptions,
): boolean {
  const { transaction } = args
  const { pattern } = options

  // Check if any instruction matches the pattern
  return transaction.transaction.message.instructions.some((instruction) => {
    // Check program ID
    if (instruction.programId !== pattern.programId) {
      return false
    }

    // Check instruction type if specified
    if (
      pattern.instructionType &&
      'parsed' in instruction &&
      instruction.parsed?.type !== pattern.instructionType
    ) {
      return false
    }

    // Check accounts if specified
    if (pattern.accounts && 'accounts' in instruction && instruction.accounts) {
      for (const [_accountName, expectedIndex] of Object.entries(
        pattern.accounts,
      )) {
        const accountAtIndex = instruction.accounts[expectedIndex]
        if (!accountAtIndex) {
          return false
        }
      }
    }

    return true
  })
}
